import { updateField } from 'vuex-map-fields';
// initial state
const initialState = {
  topUsers: null,
  errorLoadingTopUsers: false
};

// actions
const actions = {
  initialiseVariablesToNull({ commit }) {
    commit('topUsers', '');
  },
  async frequentUsers({ commit }, { platformClient, account, database, schema, table_name }) {
    commit('topUsers', '');
    commit('errorLoadingTopUsers', false);
    try {
      let result = await platformClient.post('https://nala.cimpress.io/v0/looker/run', {
        configurationId: 'e114fb92-c3bc-4246-8a8f-8da3cf308cc8',
        cosmeticFilters: [
          {
            viewName: 'frequent_users',
            dimName: 'object_name',
            filterValue: `${database.toUpperCase()}.${schema.toUpperCase()}.${table_name.toUpperCase()}`
          }
        ]
      }
      );
      commit('topUsers', result.data.lookOutput);
      commit('errorLoadingTopUsers', false);
    } catch (error) {
      commit('errorLoadingTopUsers', true);
    }
  }
};

// mutations
const mutations = {
  updateField,
  topUsers(state, topUsers) {
    state.topUsers = topUsers;
  },
  errorLoadingTopUsers(state, errorLoadingTopUsers) {
    state.errorLoadingTopUsers = errorLoadingTopUsers;
  }
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations
};
